"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as C } from "react/jsx-runtime";
import * as b from "react";
import { useRifm as x } from "rifm";
import { useFieldProps as N } from "./form-context.js";
import { TextFieldBaseAutosuggest as E } from "./text-field-base.js";
import { createChangeEvent as L } from "./utils/dom.js";
import { combineRefs as V } from "./utils/common.js";
import { useTheme as B } from "./hooks.js";
const A = {
    ES: 24,
    GB: 22,
    DE: 22,
    BR: 29
}, k = 32, F = (e, t)=>{
    let n = 0;
    for(let r = 0; r < e.length; r++)n = (n * 10 + Number(e[r])) % t;
    return n;
}, y = (e)=>/^[A-Z]{2}$/.test(e), R = (e)=>/^\d{2}$/.test(e), S = (e)=>{
    let t = e.substr(4) + e.substr(0, 4);
    const n = "A".charCodeAt(0);
    return t = Array.from(t).map((r)=>{
        if (Number.isNaN(Number(r))) {
            const o = r.charCodeAt(0);
            return String(10 + o - n);
        }
        return r;
    }).join(""), F(t, 97) === 1;
}, T = (e)=>{
    const t = e.substr(0, 2), n = e.substr(2, 2);
    if (!y(t) || !R(n)) return !1;
    const r = A[t];
    return !(r && r !== e.length || !S(e));
}, z = (e)=>{
    var n;
    const t = e.replace(/[^\dA-Za-z]/g, "");
    var _ref;
    return (_ref = (n = t.match(/.{1,4}/g)) == null ? void 0 : n.join(" ")) !== null && _ref !== void 0 ? _ref : t;
}, M = (e)=>{
    const t = e.substr(0, 2);
    let n = k;
    if (t && y(t)) {
        const o = A[t];
        o && (n = o);
    }
    const r = Math.ceil(n / 4) - 1;
    return n + r;
}, Z = (_param)=>{
    var { inputRef: e, value: t, defaultValue: n, onChange: r } = _param, o = _object_without_properties(_param, [
        "inputRef",
        "value",
        "defaultValue",
        "onChange"
    ]);
    const [u, p] = b.useState(n !== null && n !== void 0 ? n : ""), c = b.useRef(null), i = typeof t < "u", m = i ? t : u, d = b.useCallback((s)=>{
        i || p(s), c.current && (r == null || r(L(c.current, s)));
    }, [
        i,
        r
    ]), a = x({
        format: z,
        value: m,
        onChange: d,
        replace: (s)=>s.toUpperCase(),
        accept: /[\dA-Za-z]+/g
    });
    return /* @__PURE__ */ C("input", _object_spread_props(_object_spread({}, o), {
        maxLength: M(a.value),
        value: a.value,
        onChange: (s)=>{
            var h;
            const f = s.target.value, g = a.value;
            return f.length - g.length > 1 && ((h = s.nativeEvent) == null ? void 0 : h.inputType) === "insertText" && (s.target.value = g), a.onChange(s);
        },
        type: "text",
        ref: V(e, c)
    }));
}, j = (_param)=>{
    var { disabled: e, error: t, helperText: n, name: r, optional: o, validate: u, onChange: p, onChangeValue: c, onBlur: i, value: m, defaultValue: d, dataAttributes: a } = _param, s = _object_without_properties(_param, [
        "disabled",
        "error",
        "helperText",
        "name",
        "optional",
        "validate",
        "onChange",
        "onChangeValue",
        "onBlur",
        "value",
        "defaultValue",
        "dataAttributes"
    ]);
    const { texts: f } = B(), I = N({
        name: r,
        value: m,
        defaultValue: d,
        processValue: (l)=>l.replace(/[^\dA-Za-z]/g, ""),
        helperText: n,
        optional: o,
        error: t,
        disabled: e,
        onBlur: i,
        validate: (l, v)=>l ? T(l) ? u == null ? void 0 : u(l, v) : f.formIbanError : o ? "" : f.formFieldErrorIsMandatory,
        onChange: p,
        onChangeValue: c
    });
    return /* @__PURE__ */ C(E, _object_spread_props(_object_spread({}, s, I), {
        inputComponent: Z,
        dataAttributes: _object_spread({
            "component-name": "IbanField"
        }, a)
    }));
}, O = j;
export { O as default };
